// utils/salaryExport.js
import * as XLSX from 'xlsx';
import dayjs from 'dayjs';

export const exportSalaryToExcel = (salaryData, page, t) => {
  if (!salaryData || salaryData.length === 0) {
    return;
  }

  // Prepare data for export
  const exportData = salaryData.map((item, index) => {
    // Calculate net pay
    const totalAllowance = (item?.totalAllowance || 0) + (item?.otherAllowance || 0);
    const totalDeduction = (item?.totalDeduction || 0) + (item?.otherDeduction || 0);
    const netPay = totalAllowance - totalDeduction;

    return {
      '#': index + 1,
      'Employee ID': item?.Employee?.employeeId || 'N/A',
      'Employee Name': item?.Employee?.name || 'N/A',
      'Department': item?.Department?.name || 'N/A',
      'Duration': item?.JobRequests?.duration || 'N/A',
      'From Date': dayjs(item?.fromDate).format('MM-DD-YYYY'),
      'To Date': dayjs(item?.toDate).format('MM-DD-YYYY'),
      'Allowance': `$${totalAllowance.toFixed(2)}`,
      'Deduction': `$${totalDeduction.toFixed(2)}`,
      'Net Pay': `$${netPay.toFixed(2)}`,
      'Status': item?.status?.charAt(0).toUpperCase() + item?.status?.slice(1) || 'N/A',
    };
  });

  // Create worksheet
  const ws = XLSX.utils.json_to_sheet(exportData);

  // Set column widths
  const colWidths = [
    { wch: 5 },    // #
    { wch: 15 },   // Employee ID
    { wch: 20 },   // Employee Name
    { wch: 15 },   // Department
    { wch: 20 },   // Duration
    { wch: 15 },   // From Date
    { wch: 15 },   // To Date
    { wch: 12 },   // Allowance
    { wch: 12 },   // Deduction
    { wch: 12 },   // Net Pay
    { wch: 12 },   // Status
  ];
  ws['!cols'] = colWidths;

  // Create workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Salary List');

  // Generate filename with current date
  const fileName = `salary_list_${dayjs().format('YYYY-MM-DD_HH-mm')}.xlsx`;

  // Save file
  XLSX.writeFile(wb, fileName);
};